import Link from "next/link";
import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text, Button } from "@/elements";
import { LBGhoverEffect } from "styles/hoverPresets";
import WrapCards from "@/components/cardsWrap";
import { ZADARA_SERVICES_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  const TextVariant = useTextVariant();
  return (
    <Stack gap={6} align={"center"}>
      <WrapCards
        title={ZADARA_SERVICES_CONSTANTS.title}
        desc={ZADARA_SERVICES_CONSTANTS.desc}
        list={ZADARA_SERVICES_CONSTANTS.list}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Stack gap={4} align={"center"}>
        <Text variant={TextVariant} color="text.100">
          {ZADARA_SERVICES_CONSTANTS.conclusion}
        </Text>
      </Stack>
    </Stack>
  );
};

export default ServicesComponent;
